import React from 'react';

import Icon from '../Icon/Icon';

const VapingSessionNoneIcon = (props) => {
    return (
        <Icon width='48' height='48' {...props}>
            <g fill='none' fillRule='evenodd'>
                <g transform='translate(6 8.004)'>
                    <rect fill='#34303D' y='18.645' width='6' height='2' rx='1' />
                    <rect fill='#34303D' x='4.5' y='11.046' width='17' height='2' rx='1' />
                    <path
                        d='M19.69 12.04c.712.002 1.37.002 2.012-.065 2.17-.228 4.095-1.67 4.693-3.91.776-2.901-.942-5.884-3.836-6.661a5.424 5.424 0 0 0-6.645 3.846'
                        stroke='#34303D'
                        strokeWidth='2'
                        strokeLinecap='round'
                    />
                    <rect fill='#34303D' x='18.903' y='26.596' width='9' height='2' rx='1' />
                    <path
                        d='M25.89 27.581c.712.002 1.37.002 2.013-.065 2.17-.228 4.094-1.67 4.693-3.91.775-2.901-.942-5.884-3.837-6.661a5.424 5.424 0 0 0-6.645 3.846'
                        stroke='#34303D'
                        strokeWidth='2'
                        strokeLinecap='round'
                    />
                </g>
                <g transform='translate(9.036 23.086)' stroke='#34303D' strokeWidth='2'>
                    <circle fill='#FFF' cx='8.983' cy='8.983' r='7.983' />
                    <path strokeLinecap='square' d='m2.464 13.414 13-9' />
                </g>
            </g>
        </Icon>
    );
};

export default VapingSessionNoneIcon;
